import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/icon/index'
import http from './api/index'
import * as utils from '@/utils/utils'
import 'normalize.css'
import '@/assets/css/index.scss'

import { Loading, Toast, Icon, Dialog, RadioGroup, Radio, ActionSheet, } from 'vant'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import Cookies from 'js-cookie'


import {
  Carousel,
  CarouselItem,
  Tooltip
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(PerfectScrollbar)
Vue.use(preview, {
  fullscreenEl: false,
  zoomEl: false
})

Vue.use(Loading)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(ActionSheet)
Vue.use(CarouselItem)
Vue.use(Carousel)
Vue.use(Tooltip)
Vue.config.productionTip = false

Vue.prototype.$http = http
Vue.prototype.$utils = utils
Vue.prototype.$cookie = Cookies
Vue.prototype.$ = Cookies
window.eventBus = new Vue()

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
